import { render } from "./SortByDropdown.vue?vue&type=template&id=fe491cd2"
import script from "./SortByDropdown.vue?vue&type=script&lang=js"
export * from "./SortByDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__